/**
 * Import Dependency
 */
import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

/**
 * Import Component (.vue)
 * For Async Component Syntax
 * const X = () => import('@/pages/xxx/xxx.vue')
 */
import AppPages from '../pages'
import Application from "../../plugins/limitless";

/**
 * Config
 */
Vue.use(Router)

/**
 * Declare Variable
 */

const pageWhiteList = ['/', '/auth/login', '/auth/password-reset']

const router = new Router({
    mode: 'history',
    base: process.env.VUE_APP_PUBLIC_PATH,
    routes: [
        {
            path: '/auth',
            component: AppPages.Default,
            meta: {
                requiresAuth: false,
            },
            children: [
                {
                    path: 'login',
                    name: 'auth.login',
                    component: AppPages.Auth.Signin,
                    meta: {
                        requiresAuth: false,
                    }
                },
            ]
        },

        {
            path: '/',
            component: AppPages.App.Admin,
            name: 'home',
            redirect : 'dashboard',
            meta: {
                requiresAuth: true,
                breadcrumb: [
                    //{ name: 'Simply Sift'  , link : 'home' }
                ]
            },
            children: [
                {
                    path: '',
                    redirect : 'dashboard'
                },
                //dashboard
                {
                    path: 'dashboard',
                    component: AppPages.App.PageContent,
                    meta: {
                        breadcrumb: [
                            { name: 'Dashboard' , link : 'dashboard' }
                        ]
                    },
                    children: [
                        {
                            path: '',
                            name: 'dashboard',
                            component: AppPages.App.Main.Dashboard.View

                        },
                    ]
                },
                //users
                {
                    path: 'users',
                    name: 'users',
                    redirect : 'users/',
                    component: AppPages.App.PageContent,
                    meta: {
                        breadcrumb: [
                            { name: 'Users' , link : 'users-view' }
                        ]
                    },
                    children: [
                        {
                            path: '/',
                            redirect : 'view'
                        },
                        {
                            path: 'view',
                            name: 'users-view',
                            component: AppPages.App.Main.Users.View,
                            meta: {
                                breadcrumb: [
                                    { name: 'View' , link : 'users-view' }
                                ]
                            },
                            children: [
                                {
                                    path: ':page',
                                    name: 'users-view-page',
                                    meta: {
                                    },
                                }
                            ]
                        },
                        {
                            path: 'edit/:id',
                            name: 'users-edit',
                            component: AppPages.App.Main.Users.Edit,
                            props: true,
                            meta: {
                                breadcrumb: [
                                    { name: 'Edit' , link : 'users-edit' }
                                ]
                            },
                        },
                    ]
                },

            ]
        },
        {
            path: '*',
            name: '404',
            component: AppPages.Errors.Error404,
            meta: {
                requiresAuth: false
            }
        }
    ]
})

/**
 * Router Guards
 */

router.beforeEach((to, from, next) => {
    Application.sidebarMobileToggle();
    if (to.path === '/auth' || to.path === '/auth/') {
        next({
            path: '/auth/login'
        })
    }

    let _accessToken = store.getters['auth/getAccessToken'] || '';
    let _isAuthorized = store.getters['auth/getIsAuthorized'] || false;

    //console.log(to, _isAuthorized, _accessToken);

    if (to.path === '/auth/login' && _isAuthorized) {
        if (to.query && to.query.redirect) {
            next({
                path: to.query.redirect
            })
        }
        else {
            next({
                path: '/dashboard'
            })
        }
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {

        if (_accessToken && _isAuthorized) {
            next();
        } else {
            next({
                path: '/auth/login',
                query: { redirect: to.fullPath }
            })
        }
    }else{
        next();
    }
})

export default router